export default __webpack_public_path__ + "static/media/fh-logo-.f3c1038f.jpg";